<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalNamedLocations",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>D. Particulars Relating to Named Location(s)</div>"
					},
					bindTo: ""
				},
				{
					label:
						"1. Insured Property to be kept only in the following location(s) within territories covered",
					component: "select",
					bindTo: "case.facts.namedLocationDetails",
					props: {
						options: [
							{
								name: "Same as the correspondence address in Part A",
								value: "Same as the correspondence address in Part A"
							},
							{
								name: "Others",
								value: "Others"
							}
						]
					}
				},
				{
					label: '1. If chose "Others", please specify',
					component: "text",
					bindTo: "case.facts.specifiedNamedLocation"
				},
				{
					label:
						"2. Are the Named Location(s) regularly left unattended by day or night?",
					component: "select",
					bindTo: "case.facts.namedLocationLeftUnattendedSituation",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					label: '2. If chose "Yes", please give details',
					component: "text",
					bindTo: "case.facts.specifiedNamedLocationLeftUnattendedSituation"
				},
				{
					label: "3. Security Measure",
					component: "select",
					bindTo: "case.facts.securityMeasure",
					props: {
						options: [
							{
								name: "Burglar alarms",
								value: "Burglar alarms"
							},
							{
								name: "Safe in HK",
								value: "Safe in HK"
							},
							{
								name: "Other protection or security measures",
								value: "Other protection or security measures"
							}
						]
					}
				},
				{
					label: '3. If chose "Burglar alarms", please state the Provider',
					component: "text",
					bindTo: "case.facts.burglarAlarmsProvider"
				},
				{
					label: '3. If chose "Safe in HK", please state the Brand / Model',
					component: "text",
					bindTo: "case.facts.safeInHKBrandOrModel"
				},
				{
					label:
						'3. If chose "Other protection or security measures", please give details',
					component: "text",
					bindTo: "case.facts.specifiedOtherProtectionOrSecurityMeasures"
				},
				{
					label:
						"4. Is the Named Location(s) used solely as a private dwelling occupied by the Proposer in one household only?",
					component: "select",
					bindTo: "case.facts.isNamedLocationSolelyUsed",
					props: {
						options: [
							{
								name: "Yes",
								value: "Yes"
							},
							{
								name: "No",
								value: "No"
							}
						]
					}
				},
				{
					label:
						'4. If chose "No", please give details of other occupants and identity relationships',
					component: "text",
					bindTo: "case.facts.otherOccupantsAndIdentityRelationshipsDetails"
				},
				{
					label:
						"5. Is any trade, profession or business carried out at the Named Location(s)",
					component: "select",
					bindTo: "case.facts.isAnyTradeProfessionOrBusinessCarriedOut",
					props: {
						options: [
							{
								name: "No",
								value: "No"
							},
							{
								name: "Yes",
								value: "Yes"
							}
						]
					}
				},
				{
					label: '5. If chose "Yes", please give details',
					component: "text",
					bindTo: "case.facts.specifiedAnyTradeProfessionOrBusinessCarriedOut"
				}
			]
		}
	}
}
</script>
